module.exports = __webpack_public_path__ + "static/img/tuichu.df262ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tuichu.png
// module id = jNba
// module chunks = 64